//Components
import NavbarComponent from "./Components/NavbarComponent";
import SplashContainer from "./Components/SplashContainer";
import AboutContainer from "./Components/AboutContainer";
import PricingContainer from "./Components/PricingContainer";
import ContactContainer from "./Components/ContactContainer";
import Footer from "./Components/Footer";

function App() {
  return (
    <div className="App">
      <NavbarComponent />
      <SplashContainer />
      <AboutContainer />
      <PricingContainer />
      <ContactContainer />
      <Footer />
    </div>
  );
}

export default App;
